/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentOverdueIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PaymentOverdueIndicator from 'DesignSystem/PaymentOverdueIndicator/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PaymentOverdueIcon({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/PaymentOverdueIcon"
  
}) {
let eventAppointmentPatientDueAmountValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient.due_amount',
})
  return (<React.Fragment
>
<PaymentOverdueIndicator
  viewPath={`${viewPath}/PaymentOverdueIndicator`}
 data="event.appointment.patient.due_amount"
 overdues={eventAppointmentPatientDueAmountValueData}
/>
{children}
</React.Fragment>)
}